<template>
<div class="cadence-flag-queue">
  <div class="o-main-content-area o-main-content-area--padBotoomNone">
    <div class="row c-responsive-fixwidth">
      <div class="col-md-8">
        <h1 class="h1">Traffic Trap &mdash; Cadence Flags</h1>
        <p class="c-small-help" style="color:#8b949e">
          Users whose recent request timing looks machine-driven (low coefficient of variation). Auto-refreshes every 10s.
        </p>
      </div>
      <div class="col-md-4 text-right">
        <span style="color:#8b949e;font-size:0.85rem;margin-right:12px">
          {{ loading ? 'refreshing&hellip;' : lastRefresh ? 'last: ' + lastRefresh : '' }}
        </span>
        <a href="javascript: void(0)" class="c-common-btn c-common-btn--small" @click="fetchFlags">Refresh now</a>
      </div>
    </div>

    <div class="c-common-space c-common-box-shadow c-radius3" style="padding:14px">
      <table class="o-table-area" style="width:100%;font-size:0.88rem">
        <thead>
          <tr style="text-align:left">
            <th>Time</th>
            <th>User</th>
            <th>Role</th>
            <th>Client</th>
            <th>Route</th>
            <th style="text-align:right">Mean (ms)</th>
            <th style="text-align:right">CoV</th>
            <th style="text-align:right">Samples</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!flags.length && !loading">
            <td colspan="9" style="text-align:center;padding:18px;color:#8b949e">No flags in window.</td>
          </tr>
          <tr v-for="(f, i) in flags" :key="i">
            <td>{{ formatTime(f.time) }}</td>
            <td>{{ f.user_id }}</td>
            <td>{{ f.role }}</td>
            <td>{{ f.client_id || '&mdash;' }}</td>
            <td><code>{{ f.route }}</code></td>
            <td style="text-align:right">{{ f.mean_ms }}</td>
            <td style="text-align:right">{{ formatCov(f.cov) }}</td>
            <td style="text-align:right">{{ f.samples }}</td>
            <td style="white-space:nowrap">
              <a href="javascript: void(0)" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green"
                 @click="grantBypass(f)">Bypass 24h</a>
              <a href="javascript: void(0)" class="c-common-btn c-common-btn--small c-common-btn--red"
                 @click="blockUser(f)">Block 15m</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import service from '../../../services.js';

const REFRESH_MS = 10000;

export default {
  name: 'CadenceFlagQueue',

  computed: {
    ...mapGetters({ userToken: 'userToken' }),
  },

  data() {
    return {
      flags: [],
      loading: false,
      lastRefresh: '',
      timer: null,
    };
  },

  mounted() {
    this.fetchFlags();
    this.timer = setInterval(this.fetchFlags, REFRESH_MS);
  },

  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },

  methods: {
    async fetchFlags() {
      this.loading = true;
      try {
        const res = await service.get('sa/traffic/cadence-events', {
          Authorization: this.userToken,
        });
        const payload = res?.data?.result || res?.data || {};
        this.flags = payload.events || [];
        this.lastRefresh = this.formatTime(Date.now());
      } catch (err) {
        console.log('CadenceFlagQueue fetch failed:', err);
      } finally {
        this.loading = false;
      }
    },

    async grantBypass(flag) {
      const email = prompt('Email to bypass for 24h (leave blank to cancel):');
      if (!email) return;
      try {
        await service.post('sa/traffic/bypass', { email, hours: 24 }, {
          Authorization: this.userToken,
        });
        this.$notify?.success?.({ title: 'Bypass set', message: email + ' bypassed for 24h' });
      } catch (err) {
        this.$notify?.error?.({ title: 'Bypass failed', message: err?.message || 'unknown error' });
      }
    },

    async blockUser(flag) {
      if (!confirm('Block user ' + flag.user_id + ' for 15 minutes?')) return;
      try {
        await service.post('sa/traffic/block-user', { user_id: flag.user_id, minutes: 15 }, {
          Authorization: this.userToken,
        });
        this.$notify?.success?.({ title: 'Blocked', message: flag.user_id + ' blocked for 15m' });
      } catch (err) {
        this.$notify?.error?.({ title: 'Block failed', message: err?.message || 'unknown error' });
      }
    },

    formatTime(ms) {
      if (!ms) return '';
      return new Date(Number(ms)).toLocaleTimeString();
    },

    formatCov(cov) {
      if (cov == null) return '';
      return Number(cov).toFixed(4);
    },
  },
};
</script>

<style scoped>
.cadence-flag-queue table th {
  padding: 8px 10px;
  border-bottom: 2px solid #30363d;
  color: #8b949e;
  font-weight: 600;
}
.cadence-flag-queue table td {
  padding: 7px 10px;
  border-bottom: 1px solid #21262d;
  vertical-align: top;
}
</style>
